import React, { useMemo } from "react";

import PrintFinanceBars from "../common/PrintFinanceBars";
import { formatPrintMoney } from "../financePrintUtils";

const toNum = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Compact daily-balance header: horizontal bars + KPI strip (no tall chart).
 */
const PrintDailyBalanceSummary = ({ summary = {} }) => {
  const { yesterdayBalance, totalRevenue, totalExpense } = summary;

  const revenue = toNum(totalRevenue);
  const expense = toNum(totalExpense);
  const hasYesterday =
    yesterdayBalance != null &&
    yesterdayBalance !== "" &&
    !Number.isNaN(Number(yesterdayBalance));
  const yesterday = hasYesterday ? toNum(yesterdayBalance) : null;
  const dayNet = revenue - expense;
  const currentBalance = hasYesterday ? yesterday + dayNet : dayNet;

  const barRows = useMemo(
    () => [
      { label: "درآمد امروز", value: revenue, color: "#075da9" },
      { label: "مصارف امروز", value: expense, color: "#b75555" },
      { label: "بیلانس", value: dayNet, color: "#48C29D" },
    ],
    [revenue, expense, dayNet]
  );

  const kpis = useMemo(() => {
    const rows = [];
    if (hasYesterday) {
      rows.push({ label: "بیلانس روز قبل", value: yesterday });
    }
    rows.push(
      { label: "درآمد امروز", value: revenue },
      { label: "مصارف امروز", value: expense },
      { label: "بیلانس فعلی", value: currentBalance, emphasis: true }
    );
    return rows;
  }, [hasYesterday, yesterday, revenue, expense, currentBalance]);

  const expenseShare =
    revenue + expense > 0 ? (expense * 100) / (revenue + expense) : 0;

  return (
    <div className="print-daily-balance-summary">
      <div className="print-daily-balance-bars">
        <PrintFinanceBars
          rows={barRows}
          percentLabel="سهم مصارف"
          percent={expenseShare}
        />
      </div>
      <div className="print-daily-balance-kpis">
        {kpis.map(({ label, value, emphasis }) => (
          <div
            key={label}
            className={`print-daily-balance-kpi${emphasis ? " is-emphasis" : ""}`}
          >
            <p className="print-daily-balance-kpi-label">{label}</p>
            <p className="print-daily-balance-kpi-value print-ltr-amount">
              {formatPrintMoney(value)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrintDailyBalanceSummary;
